<template>
  <div class="wrap data-area block-shadow">
    <div class="title">密码重置</div>
      <div v-show="!nextStepStatus">
        <div class="h20"></div>
        <Form ref="formValidateFirst" :model="reset" :rules="ruleFirstStep" :label-width = "200">
          <FormItem prop="mobile" label="手机号码 :" class="long-input">
            <Input v-model.trim="reset.mobile" placeholder="请输入手机号码" :maxlength="11"></Input>
          </FormItem>
          <FormItem prop="code" label="验证码 :" class="short-input">
            <Input v-model.trim="reset.code" placeholder="请输入验证码" :maxlength="4"></Input>
            <img :src="captcha" v-on:click="picReload" class="pointer captcha ml20 sensors-data"/>
          </FormItem>
           <FormItem prop="msgCode" label="短信验证码 :" class="short-input">
            <Input v-model.trim="reset.msgCode" placeholder="请输入您收到的短信验证码" :maxlength="6"></Input>
            <a href="javascript:;" class="btn ml20" :class="{'bg-c0cadd': sendMsgBoxStaus === 'sending'}" v-on:click="sendMsg">{{sendMsgText}}</a>
          </FormItem>
        </Form>
        <div class="h60"></div>
        <div class="line1"></div>
        <div class="tac">
            <input type="button" value="下一步" class="btn" @click="nextStep">
        </div>
        <div class="h200"></div>
      </div>
      <div v-show="nextStepStatus">
        <div class="h20"></div>
        <Form ref="formValidateSecond" :model="pass" :rules="ruleSecondStep" :label-width = "200">
          <FormItem prop="password" label="新密码 :" class="long-input">
            <Input type="password" v-model.trim="pass.password" placeholder="请输入新密码" :maxlength="20"></Input>
          </FormItem>
          <FormItem prop="confirmPass" label="确认新密码 :" class="long-input">
            <Input type="password" v-model.trim="pass.confirmPass" placeholder="请再次输入密码" :maxlength="20"></Input>
          </FormItem>
        </Form>
        <div class="h60"></div>
        <div class="line1"></div>
        <div class="tar">
            <input type="button" value="确认" class="btn" v-on:click="savePassword" :loading= "savePasswordLoading">
            <a class="btn ml10 middle-style" href="../finance/login">取消</a>
        </div>
      </div>
    <!--短信提示框-->
    <Modal v-model="sendMsgBoxModal" title="提示信息" width="600">
       短信验证码已经发送到您的手机上，5分钟内输入有效，请注意查收，如非本人操作请忽略！
       <div slot="footer">
          <Button type="primary" @click="sendMsgBoxModal = false">关闭</Button>
      </div>
    </Modal>
    <!-- 密码修改成功弹窗 -->
    <Modal v-model="codeSaveSuccModal" title="提示信息" width="600">
      <p>您的登录密码已重置成功！系统将于3秒后自动跳转到登录页面，谢谢！
        <a href="../finance/login" class="blue-style"> 点击此处</a> 直接跳转。
      </p>
       <div slot="footer">
          <Button type="primary" @click="codeSaveSuccModal = false">确认</Button>
      </div>
    </Modal>
    <Modal v-model="tip.isTip" title="提示信息" width="600">
      {{tip.txt}}
       <div slot="footer">
          <Button type="primary" @click="tip.isTip = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import '@/styles/index.less'
import as from '@/libs/ajax'
import { getPublicKey, encryptPwd, regExp } from '../../libs/util'

export default {
  name: 'reset-password',
  data () {
    return {
      tip: {
        isTip: false,
        txt: ''
      },
      reset: {},
      pass: {},
      nextStepStatus: false,
      sendMsgBoxModal: false,
      codeSaveSuccModal: false,
      savePasswordLoading: false,
      captchaURL: '/uaa/v1/captcha/image',
      captcha: '',
      sendMsgText: '获取验证码',
      sendMsgBoxStaus: '',
      switchBool: false,
      publicKey: '',
      ruleFirstStep: {
        fiCode: [{ required: true, message: '此处不能为空' }],
        corpName: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('此处不能为空'))
            } else if (!/^.{1,80}$/.test(value)) {
              callback(new Error('企业全称格式错误，请重新输入'))
            } else {
              callback()
            }
          }
        }],
        mobile: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('此处不能为空'))
            } else if (!/^1[3-9]\d{9}$/.test(value)) {
              callback(new Error('手机号码格式错误，请填写11位手机号码'))
            } else {
              callback()
            }
          }
        }],
        code: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('此处不能为空'))
            } else if (!/^.{4}$/.test(value)) {
              callback(new Error('请输入4位验证码'))
            } else {
              callback()
            }
          }
        }],
        msgCode: [{ required: true, message: '此处不能为空' }]
      },
      ruleSecondStep: {
        password: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('此处不能为空'))
            } else if (!regExp.newPassword.test(value)) {
              callback(new Error('请输入8至20位的数字、大小写字母及特殊字符4种类型字符的组合'))
            } else {
              callback()
            }
          }
        }],
        confirmPass: [{
          required: true,
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('此处不能为空'))
            } else if (!regExp.newPassword.test(value)) {
              callback(new Error('请输入8至20位的数字、大小写字母及特殊字符4种类型字符的组合'))
            } else if (this.pass.password !== this.pass.confirmPass) {
              callback(new Error('两次输入的密码不一致，请重新输入。'))
            } else {
              callback()
            }
          }
        }]
      }
    }
  },
  created () {
    this.picReload()
    getPublicKey().then((res) => { this.publicKey = res })
  },
  methods: {
    picReload () {
      this.captcha = this.captchaURL + '?nocache=' + new Date().getTime()
      var image = new Image()
      image.src = this.captcha
      // console.log('picReload')
    },
    // 发送短信验证码
    sendMsg () {
      if (this.sendMsgBoxStaus === 'sending') return // 正在发送验证 直接返回
      this.$refs['formValidateFirst'].validateField('mobile', err => {
        if (err) return
        this.$refs['formValidateFirst'].validateField('code', err => {
          if (err) return
          this.sendMsgBoxStaus = 'sending'
          let _this = this
          let timer
          let n = 60
          clearInterval(timer)

          as.post('/v1/sms/' + this.reset.mobile + '/verification/codes?picChkCode=' + this.reset.code).then(res => {
            if (res.code === '0') {
              _this.sendMsgBoxModal = true
              timer = setInterval(function () {
                n--
                _this.sendMsgText = '还有' + n + '秒'
                if (n <= 0) {
                  clearInterval(timer)
                  _this.sendMsgText = '重新获取'
                  _this.sendMsgBoxStaus = ''
                }
              }, 1000)
            } else {
              _this.tip.txt = res.message
              _this.tip.isTip = true
              clearInterval(timer)
              _this.sendMsgText = '重新获取'
              _this.sendMsgBoxStaus = ''
              _this.picReload()
            }
          }).catch(err => {
            // console.log(err)
          })
        })
      })
    },
    nextStep () {
      var _this = this
      this.$refs['formValidateFirst'].validate((valid) => {
        if (valid) {
          as.post('/v1/users/persons/forget/password/finance/verify', {
            // corpName: _this.reset.corpName,
            mobilePhone: _this.reset.mobile,
            smsVerifyCode: _this.reset.msgCode
          }).then(res => {
            if (res.code === '0') {
              _this.nextStepStatus = true
            } else {
              _this.$Tip.error({
                content: res.message,
                okText: '确定'
              })
              _this.picReload()
            }
          }).catch(err => {
            // console.log(err)
          })
        }
      })
    },
    savePassword () {
      var _this = this
      this.$refs['formValidateSecond'].validate((valid) => {
        if (valid) {
          _this.savePasswordLoading = true
          as.post('/v1/users/persons/finance/forget/password', {
            password: encryptPwd(_this.publicKey, _this.pass.password),
            confirmPass: encryptPwd(_this.publicKey, _this.pass.confirmPass)
          }).then(res => {
            _this.savePasswordLoading = false
            if (res.code === '0') {
              _this.codeSaveSuccModal = true
              setTimeout(function () {
                window.location.href = '../finance/login'
              }, 3000)
            } else {
              _this.$Tip.error({
                content: res.message,
                okText: '确定'
              })
            }
          }).catch(err => {
            // console.log(err)
          })
        }
      })
    }
  }
}
</script>
<style lang="less">
@import '~@/styles/var';
@title-color: #666666;
@title-size: 22px;
@fs30: 30px;
@fs20: 20px;
.wrap {
  width: @page-width;
  margin: 0 auto;
  margin-top: 20px;
}
.bg-c0cadd{
  background-color: #c0cadd !important;
  border: 1px solid #c0cadd;
}
.wrap {
  .title {
    font-size: @title-size;
    color: @title-color;
    padding-bottom: 20px;
    font-weight: bold;
    height: 74px;
    line-height: 74px;
    border-bottom: 1px solid #bad4f1;
  }
  .blue-style{
    color: #004da9;
    cursor: pointer;
  }
  .h200{
    height: 200px;
  }
  .h20{
    height: 20px;
  }
  .h60{
    height: 60px;
  }
  .width350{
    width:350px;
  }
  .long-input input {
    width: 350px;
    height: 36px;
  }
  .short-input .ivu-input-type{
    width: 220px;
  }
  .short-input input{
    width: 220px;
    height: 36px;
  }
  .captcha {
    width: 110px;
    height: 36px;
  }
  .btn{
    width: 108px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    color: #fff;
    background-color: @basic-color;
    font-weight: 700;
  }
  .line1 {
    margin: 10px 0 20px;
    height: 1px;
    background: #d2def2;
  }
  .middle-style {
    vertical-align: middle;
  }
}
</style>
